
export function Hondt(partits,limit,totalEscons)
{
    this.partits=partits;
    this.numPartits=partits.length;
    this.limit=limit;
    this.vots=new Array();
    this.escons=new Array();
    this.totalEscons = totalEscons;
    this.blancs=-1;
    this.votsTotals=0;

    this.setVots=_setVots;
    this.nouEsco=_nouEsco;
    this.calculEscons=_calculEscons;
    this.getEscons=_getEscons;

    function _getEscons(_nom)
    {
        var i=0;

        while(i<this.partits.length)
        {
            if(this.partits[i]==_nom)
                return this.escons[i];
            i++;
        }

        return 0;
    }

    function _setBlancs(_vots)
    {
        this.blancs=_vots;
    }

    function _setVots(_nom,_vots)
    {
        var i=0;

        while(i<this.partits.length)
        {
            if(this.partits[i]==_nom)
                this.vots[i]=_vots;
            i++;
        }
    }


    function _nouEsco()
    {
        var imax=0, i;
        var max=0;

        for(i=0;i<this.numPartits;i++)
        {
            if(max<(this.vots[i]/(this.escons[i]+1)))
            {
                max=this.vots[i]/(this.escons[i]+1);
                imax=i;
            }
        }

        return imax;
    }


    function _calculEscons()
    {
        if((this.partits.length!=this.vots.length)||(this.blancs==-1))
        {
            alert('No s\'han intdroduit totes les dades dels vots');
            return false;
        }

        var numPartits=this.partits.length;

        var totalVots = 0;
        var minVots = 0;
        var i = 0;

        for(i=0;i<numPartits;i++)
        {
            totalVots+=this.vots[i];
        }

        totalVots+=this.blancs;
        minVots=totalVots*0.05;

        let numEscons=this.totalEscons;

        for (i=0; i<numPartits; i++) this.escons[i]=0;

        for (i=0; i<numEscons; i++) this.escons[this.nouEsco()]++;

        this.votsTotals=totalVots;

        return true;
    }
}
